import { colors } from "src/styles/theme";
import styled from "styled-components";
import { IoSearchOutline } from "react-icons/io5";

export default function FindInput(props: {
  label?: string;
  required?: boolean;
  onClick?: () => void;
  selectedName?: string;
  tabIndex?: number;
  id?: string;
}) {
  return (
    <Container
      $active={Boolean(props.selectedName)}
      className="d-flex gap-1"
      onClick={() => {
        props.onClick && props.onClick();
      }}
    >
      {(props.label || props.required) && (
        <div className="lb d-flex jc-c ai-c">
          <span className="rq">{props.required ? "*" : ""}</span>
          {props.label}
        </div>
      )}
      <div
        id={props.id}
        className="input-box-type flex-1 d-flex jc-sb ai-c pd-2 cursor-p"
        tabIndex={props.tabIndex}
      >
        <div className="club-name">{props.selectedName}</div>
        <IoSearchOutline size={25} className="find-icon" />
      </div>
    </Container>
  );
}

const Container = styled.div<{ $active?: boolean }>`
  .find-icon {
    color: ${colors.gray.first};
  }
  .lb {
    flex-basis: 30px;
    background-color: ${colors.gray.second};
    .rq {
      color: red;
    }
  }
  .input-box-type {
    border-color: ${(p) => (p.$active ? colors.blue.third : colors.gray.second)};
    &:focus {
      outline: auto;
      border-color: #00000000;
      outline-color: ${colors.blue.third};
    }
  }
`;
